import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { DatePipe } from '@angular/common';
import { TravelService } from '../../services/travel/travel.service';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import {AIRLINES} from 'src/app/modules/shared/common/api';

@Component({
  selector: 'app-travel-booking-add',
  templateUrl: './travel-booking-add.component.html',
  styleUrls: ['./travel-booking-add.component.scss']
})
export class TravelBookingAddComponent implements OnInit {

  travel: Travel;
  formGroup: FormGroup;
  loading:boolean = false;
  successMessage: String = '';
  fDate: any;
  tDate: any;
  msg:any;
  total = 0;
  mealTotal = 0;
  temporaryValue = {};
  transportationOption = ["Airplane","Boat","Bus","Van","Taxi","Jeepney","Tricycle","Habal-Habal"];
  companyOption = AIRLINES;

  dialogConfig:any;
  summaryDetail:any;

  province = [
    {
      origin:'',
    },
    {
      destination: ''
    }
  ];

  city = [
    {
      city:''
    },
    {
      city: ''
    }
  ];

  barangay = [
    {
      barangay:''
    },
    {
      barangay: ''
    }
  ];
 

  pipe = new DatePipe('en-US');

  constructor(
    public dialogRef: MatDialogRef<TravelBookingAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public addressService: AddressService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.travel = this.data.travel;
    this.formGroup = this.formBuilder.group({
      travel_authorization_id: ['',null],
      airlines:['',null],
      flight_no:['',null],
      departure_date: ['',null],
      arrival_date:['',null],
      departure_time: ['',null],
      arrival_time:['',null],
      baggage_allowance: ['',null]
    });
    this.getProvince();
    this.travel.formGroup = this.formGroup;

    this.fDate = this.data.travel.itinerary_date;
    this.tDate = this.data.travel.itinerary_date;
  }

  
  closeOnClick() {
    this.dialogRef.close('');
  }

  save(){
    this.formGroup.controls['departure_date'].setValue(this.pipe.transform(this.formGroup.controls['departure_date'].value, 'yyyy-MM-dd'));
    this.formGroup.controls['arrival_date'].setValue(this.pipe.transform(this.formGroup.controls['arrival_date'].value, 'yyyy-MM-dd'));
    if(this.formGroup.controls['departure_time'].value == this.formGroup.controls['arrival_time'].value || this.formGroup.controls['arrival_time'].value < this.formGroup.controls['departure_time'].value){
      (err =>{
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      })
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: 'Arrival time should be ahead of the Departure time.'
        }
      })
      this.formGroup.controls['departure_time'].setValue('')
      this.formGroup.controls['arrival_time'].setValue('')
    }
    else{
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: 'Booking has been added.'
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(this.formGroup.getRawValue());
        }
      });
    }
  }

  close() {
    this.dialogRef.close(this.formGroup.getRawValue());
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  changeCity(id,i){
    this.addressService.getCity(id).subscribe(res=>{
      this.city[i].city = res;
    });
  }

  changeBarangay(id,i){
    this.addressService.getBarangay(id).subscribe(res=>{
      this.barangay[i].barangay = res;
    });
  }

  getProvince(){
    this.addressService.getProvince().subscribe(res=>{
      this.province[0].origin = res;
      this.province[1].destination= res;
    });
  }

  onChangeStartDate(e) {
    this.fDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  onChangeEndDate(e) {
    this.tDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

}
